import type { Dispatch } from 'redux';
import type { Board } from '@atlassian/jira-boards-common/src/model/index.tsx';
import type { OperationFailureReason } from '@atlassian/jira-boards-common/src/model/operations.tsx';
import DeleteModal from '@atlassian/jira-delete-boards-modal/src/index.tsx';
import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { type Action, deleted, deleteFailed } from '../../state/actions/operations/index.tsx';
import { getBoard } from '../../state/selectors/boards/index.tsx';
import type { State } from '../../state/types.tsx';

const mapStateToProps = (state: State, ownProps: OperationModalProps<Board>) => ({
	board: getBoard(state, ownProps.entityId),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OperationModalProps<Board>) => ({
	onInitialised: ownProps.onDialogShown,
	onBoardDeleted: (board: Board): void => {
		dispatch(deleted(board));
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	},
	onBoardDeleteFailed: (board: Board, reason: OperationFailureReason) =>
		dispatch(deleteFailed(board, reason)),
	onCancel: ownProps.onCancel,
});

// @ts-expect-error – (2345) - Type 'undefined' is not assignable to type 'Board'
export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);
